export default {
  badge: "Orange County, California",
  headline1: "Your Food Truck Journey",
  headline2: "Starts With the Right Paperwork",
  subtitle:
    "Orange County's 1st food truck consulting agency. We handle permits, health department approvals, and city regulations so you can focus on serving great food.",
  bookSession: "Book a Session",
  exploreServices: "Explore Our Services",
  phases: ["Client Consultation", "Permit Paperwork", "Regulatory Review", "Permit Approved"],
};